export const MAX_SERVICES_PER_BOOKING = 5;
export const GUEST_INFO = "GUEST_INFO";
export const X_Tenant_Id = "X-Tenant-Id";
export const WS_ACTION_TYPE = {
  CREATE_BOOKING: "CREATE_BOOKING",
};
export const WS_ACTION = {
  BOOKING_RESOLVER: "booking-resolver",
};
export const USER_INFO = "USER_INFO";

export const SERVICES_RESCHEDULE = "SERVICES_RESCHEDULE";

export const BOOKING_SOURCE = {
  POS: "POS",
  ONLINE: "ONLINE",
};
